export const STOCK_CATEGORIES = ["portable", "generator", "engine", "alternator"] as const;

export type StockCategory = (typeof STOCK_CATEGORIES)[number];

export const STOCK_CATEGORY_LABELS: Record<StockCategory, string> = {
	portable: "stockCategoryPortable",
	generator: "stockCategoryGenerator",
	engine: "stockCategoryEngine",
	alternator: "stockCategoryAlternator",
};

export function isStockCategory(value: string): value is StockCategory {
	return (STOCK_CATEGORIES as readonly string[]).includes(value);
}
